module.exports = __webpack_public_path__ + "img/AMBSlot_lobby_tab_pic3.55f77c92.png";